import { render, staticRenderFns } from "./StaffActiveSuccess.vue?vue&type=template&id=94e2da46&scoped=true&"
import script from "./StaffActiveSuccess.vue?vue&type=script&lang=js&"
export * from "./StaffActiveSuccess.vue?vue&type=script&lang=js&"
import style0 from "./StaffActiveSuccess.vue?vue&type=style&index=0&id=94e2da46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e2da46",
  null
  
)

export default component.exports